import axios from '@/services/api';


export const getNaturals = async ({ commit }, params) => {

    const response = await axios.get('/natural_spaces', { params: params})

    const { data } = response;

    try {
        if (data) {
            commit('setNaturals', data);
        }

    } catch (e) {
        console.log(e);
    }

};

export const getNaturalById = async ({ commit }, id) => {
    commit('setCurrentNatural', null);
    const response = await axios.get(`/natural_spaces/${id}`)

    const { data } = response;

    try {
        if (data) {
            commit('setCurrentNatural', data);
        }

    } catch (e) {
        console.log(e);
    }
}

export const add = async (_, payload) => {

    return await axios.post("natural_spaces", payload)
        .then((response) => response)
        .catch((e) => e.response);
};

export const edit = async (_, payload) => {

    if (payload instanceof FormData) {
        return await axios.post("natural_spaces", payload)
            .then((response) => response)
            .catch((e) => e.response);
    } else {
        return await axios.put("natural_spaces/" + payload['id'], payload)
            .then((response) => response)
            .catch((e) => e.response);
    }
    
};

export const removeImage = async (_, id) => {

    return await axios.delete("natural_space_images/" + id)
        .then((response) => response)
        .catch((e) => e.response);
};

export const deleteNatural= async ({ commit }, id) => {

    await axios.delete(`/natural_spaces/${id}`)

    try {
        commit('setLoading', false);
    } catch (e) {
        console.log(e);
    }
};

